import { request } from '@/utils/request'

interface body {
  __type: string,
  __uuid: string
}

export const unDelete = (body: body) => {
  return request('/api/node/undelete', {
    method: 'POST',
    body: JSON.stringify(body)
  })
}
